import { render, staticRenderFns } from "./Dispenser.vue?vue&type=template&id=5a2de4a9&scoped=true&"
import script from "./Dispenser.vue?vue&type=script&lang=js&"
export * from "./Dispenser.vue?vue&type=script&lang=js&"
import style0 from "./Dispenser.vue?vue&type=style&index=0&id=5a2de4a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2de4a9",
  null
  
)

export default component.exports